import { ReactNode } from "react";

type AvailableIntegrationCardExplanationWrapperProps = {
  children?: ReactNode;
};

export const AvailableIntegrationCardExplanationWrapper = (
  props: AvailableIntegrationCardExplanationWrapperProps
) => {
  return (
    <div style={{ padding: "5px 0", flexGrow: 1 }}>
      <div style={{ textAlign: "left" }}>{props.children}</div>
    </div>
  );
};
